export default "__VITE_ASSET___4$cRO4V__"